import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CourseImpressionGADirective, CourseProfileGADirective } from '@uc/web/analytics';
import { Product } from '@uc/shared/data-models';
import { BookmarkComponent } from '@uc/web/shared/features/feature-bookmark';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CourseDetails } from '../../models/course-search.models';

@Component({
	selector: 'uc-course-card',
	templateUrl: './course-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		BookmarkComponent,
		NgClass,
		RouterLink,
		CourseImpressionGADirective,
		CourseProfileGADirective,
	],
})
export class CourseCardComponent {
	course = input.required<CourseDetails>();
	uniId = input.required<number>();
	uniName = input.required<string>();
	uniSlug = input.required<string>();
	product = input.required<Product>();
	isFirst = input.required<boolean>();
	isLast = input.required<boolean>();
	ugSearchOrderPosition = input.required<number | null>();
	cleSearchOrderPosition = input.required<number | null>();
	searchTerm = input.required<string>();
	isHECoSSubject = input.required<boolean | null>();
	degreeLevel = input.required<string>();
	region = input.required<string>();
}
